import { type ReactElement } from 'react'
import { Group, Radio, Stack, Text } from '@mantine/core'
import { type MaterialSymbolType, useTranslation } from '@front/model'
import { MaterialSymbolIcon } from '@components'

type Props = {
  value: string
  icon: MaterialSymbolType
  title: string
  description: string
}

/**
 * One audience choice. Built on `Radio.Card` rather than `TRadioCard` because
 * each option carries an icon, which `TRadioCard`'s string-only label can't hold.
 */
export function DashboardAudienceOptionCard({ value, icon, title, description }: Props): ReactElement {
  const { t } = useTranslation()

  return (
    <Radio.Card className='p-3xl' value={value}>
      <Group align='flex-start' gap='sm' wrap='nowrap'>
        <MaterialSymbolIcon icon={icon} size='xl' />
        <Stack gap={2}>
          <Text fw={600} lh={1.3} size='sm'>
            {t(title)}
          </Text>
          <Text c='dimmed' size='xs'>
            {t(description)}
          </Text>
        </Stack>
        <Radio.Indicator className='ml-auto' />
      </Group>
    </Radio.Card>
  )
}
